'use client'
import { Flex, Text } from '@chakra-ui/react';
import React, {useContext} from 'react';
import PersonaBioForm from './personaBioForm';
import { PersonaContext } from '../../lib/personaContext';
import InlineFormWrapper from '@/components/inlineFormWrapper';
import { PersonaPageContext } from '../lib/personaPageContext';
export default function PersonaBio(props) {
  const {
    persona,
    rights,
  } = useContext(PersonaContext);
  const {
    setEditingBio,
    editingBio
  } = useContext(PersonaPageContext);
  return (
    <>
    {persona && (persona.bio || editingBio)  && (
      <Flex
      p={3}
      flexDirection={"column"}
        borderBottom="1px"
        borderColor="divider.grey"
      >
      <Flex
          bg="background.white"
          p={3}
          flexDirection={"column"}
          border={"1px solid"}
          borderColor={"divider.grey"}
        >
          <Text
            color="text.dark.grey"
            fontSize={"18px"}
            fontWeight={"500"}
            mb={1}
            >
            Bio
          </Text>
          <InlineFormWrapper
              canEdit={rights.can_update}
              width={"100%"}
              toggle={editingBio}
              onToggle={(toggle) => {
                setEditingBio(toggle);
              }}
              value={
                <Text>
                  {persona.bio}
                </Text>
              }
            >
              {(close) => (
                <PersonaBioForm
                  onSubmitted={() => {
                    close();
                    setEditingBio(false);
                  }}
                  onCancel={() => {
                    close();
                    setEditingBio(false);
                  }}
                />
              )}
            </InlineFormWrapper>
        </Flex>
      </Flex>
     )
    }
    </>
  )
}
